import { useState, useRef, useEffect } from 'react';
// @mui
import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import InstantGuidePopoverComponent from './InstantGuidePopoverComponent';
import Iconify from '../../components/Iconify';
// ----------------------------------------------------------------------

const InfoText = styled('span')(({ theme }) => {
  return {
    color: theme.palette.info.main,
  };
});

export default function InstantGuidePopover({ sx, bluePosition='first', openStart=false }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  useEffect(() => {
    setOpen(openStart);
  }, [openStart])

  return (
    <>
      <Stack
        direction="row"
        spacing={.5}
        sx={{ mb: 3, cursor: 'pointer', alignItems: 'center', ...sx }}
        onClick={handleOpen}
        ref={menuRef}
      >
        <Iconify icon={"eva:info-fill"} sx={{ minWidth: 24, width: 24, height: 24, color: 'info.main' }} />
        {bluePosition === 'first' && (
        <Typography variant="body2">
          <b><InfoText>주 10시간</InfoText>, 4주 200만원</b>을 추천드려요.
        </Typography>
        )}
        {bluePosition !== 'first' && (
        <Typography variant="body2">
          <b>주 10시간, <InfoText>4주 200만원</InfoText></b>을 추천드려요.
        </Typography>
        )}
      </Stack>

      <InstantGuidePopoverComponent
        open={Boolean(open)}
        anchorEl={menuRef.current}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1,
          ml: 0.5,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ p: 1.5 }}>
          <Stack>
            <Typography variant="subtitle2" noWrap>
              즉시 매칭 계약 성공률이 가장 높은 조건이에요.
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              일해보고 매달 계약을 연장할 때 적절한 조건으로 변경할 수 있어요.
            </Typography>
          </Stack>
        </Box>
      </InstantGuidePopoverComponent>
    </>
  );
}
